var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31__x2C_5",
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 22c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13 14c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21 6c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m4.95 18.19c-.22 0-.438-.096-.586-.281-.259-.324-.206-.795.117-1.054l6.1-4.88c.323-.257.795-.207 1.055.117.259.324.206.795-.117 1.054l-6.1 4.88c-.139.11-.304.164-.469.164z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m14.77 9.98c-.192 0-.384-.073-.53-.22-.293-.293-.293-.768 0-1.061l4.46-4.459c.293-.293.768-.293 1.061 0s.293.768 0 1.061l-4.461 4.459c-.147.147-.338.22-.53.22z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m4 11c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m21 16c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m12 24c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m10.691 19.62c-.252 0-.498-.126-.64-.357l-5.381-8.74c-.216-.353-.107-.815.246-1.032.355-.218.815-.107 1.032.246l5.381 8.74c.217.353.107.814-.245 1.032-.123.075-.259.111-.393.111z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m13.87 20.09c-.206 0-.412-.085-.561-.251-.275-.31-.247-.784.062-1.059l5.26-4.68c.307-.274.781-.249 1.059.062.275.31.247.784-.062 1.059l-5.26 4.68c-.142.126-.32.189-.498.189z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.7ace2dc6.svg";
export { ForwardRef as ReactComponent };